import { render, staticRenderFns } from "./TheText.vue?vue&type=template&id=77e3c02f&scoped=true"
import script from "./TheText.vue?vue&type=script&lang=ts"
export * from "./TheText.vue?vue&type=script&lang=ts"
import style0 from "./TheText.vue?vue&type=style&index=0&id=77e3c02f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e3c02f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CoreSearchTheTextDropdown: require('/usr/src/nuxt-app/components/core/search/TheTextDropdown.vue').default})
